import React, { useState, useEffect } from 'react';
import { Menubar } from 'primereact/menubar';
import '../navbar/navbar.css';
import { Avatar } from 'primereact/avatar';
import { Sidebar } from 'primereact/sidebar';
import vconnect_sidebar_logo from '../../../assets/images/vconnect/sidebar-logo.png';
import atomberg_sidebar_logo from '../../../assets/images/atomberg/sidebar-logo.png';
import nkg_sidebar_logo from '../../../assets/images/nkg/sidebar-logo.png';
import softGel_sidebar_logo from '../../../assets/images/softGel/sidebar-logo.png';
import atomberg_nav_logo from '../../../assets/images/atomberg/navbar-log.png';
import den_hathway_logo from '../../../assets/images/den/sidebar_hathway.png';
import { Decoder } from '../../../Utils/js/Decoder.js';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { baseUrl, apiCommon, getUserAllData, apiAuth, chatUrl, client } from '../../../Constants/index.js';
import { IoMdArrowDropdown, IoMdArrowDropup } from 'react-icons/io';
import { FiBookOpen } from 'react-icons/fi';
import { Dialog } from 'primereact/dialog';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import Oval from '../../pages/loader/circleLoader.js';
import Swal from 'sweetalert2';
import { ToastContainer, toast, Bounce } from 'react-toastify';
import { Tooltip } from 'primereact/tooltip';
import { Badge } from 'primereact/badge';
import { useSelector } from 'react-redux';
import { getNotificationTime } from '../../../Utils/js/dateFormat.jsx';
import { resetChatNotificationData, setChatNotificationData } from '../../../redux/actions/chatNotification.js';
import { useDispatch } from 'react-redux';
import { setmailData } from '../../../redux/actions/mailRedirectAction.js';


const buildSidebarMenu = (menu = []) => {
  return menu;
};

export default function Navbar() {
  const navigate = useNavigate();
  let userAllData = getUserAllData();
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');
  const notificationData = useSelector(state => state.chatNotificationData.data || []);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState('');
  const [resetPass, setResetPass] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [navbarData, setNavbarData] = useState(null);
  const [openMenu, setOpenMenu] = useState(null);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const sidebarMenu = buildSidebarMenu(navbarData || []);

  const resetPassFormik = useFormik({
    initialValues: {
      oldPass: '',
      newPass: '',
      confirmPass: '',
    },
    validate: data => {
      let errors = {};
      if (!data.oldPass) {
        errors.oldPass = 'Old password is required';
      }
      const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,16}$/;
      if (!data.newPass) {
        errors.newPass = 'New password is required';
      } else if (!pattern.test(data.newPass)) {
        errors.newPass = 'The password you entered does not align with our security guidelines.';
      }

      if (!data.confirmPass) {
        errors.confirmPass = 'Confirm password is required';
      } else if (data.newPass && data.confirmPass !== data.newPass) {
        errors.confirmPass = 'Passwords do not match';
      }
      return errors;
    },
    onSubmit: data => {
      handleResetPassword(data);
    },
  });
  const isResetFormFieldValid = name => !!(resetPassFormik.touched[name] && resetPassFormik.errors[name]);
  const getResetFormErrorMessage = name => {
    return isResetFormFieldValid(name) && <small className="error-msg-login">{resetPassFormik.errors[name]}</small>;
  };

  useEffect(() => {
    handleNavbar();
    getChatNotificationService();
  }, []);

  // api call for get side bar data
  const handleNavbar = async () => {
    await axios.post(`${baseUrl}${apiCommon}GetUserMenu`,
      {
        UserID: userAllData[0]?.userId,
        ObjCommon: {
          LoggedInUserID: userAllData[0]?.loginUserId,
          CompanyID: userAllData[0]?.companyId,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(res => {
        const dt = res.data;
        if (res.status === 200 && dt.responseCode === '1') {
          localStorage.setItem('user_menu', dt?.responseDynamic);
          const encryptData = Decoder(dt?.responseDynamic);
          setNavbarData(encryptData?.GetUserMenu);
        }
      })
      .catch(err => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          // alert('Unauthorized! Please login again.')
        }
      });
  };

  // api call for get chat notification
  const getChatNotificationService = async () => {
    await axios
      .post(
        `${chatUrl}APICHATHUB/GetNotifications`,
        {
          UserCode: userAllData[0]?.userId,
          CompanyCode: userAllData[0]?.sappCompanyCode,
          ObjCommon: {
            LoggedInUserID: userAllData[0]?.loginUserId,
            CompanyID: userAllData[0]?.companyId,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(res => {
        const dt = res?.data;
        if (res.status === 200 && dt.responseCode === '1') {
          const encryptData = Decoder(dt?.responseDynamic);
          dispatch(setChatNotificationData(encryptData, null));
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  // api call for reset password
  const handleResetPassword = async data => {
    setLoading(true);
    const vendor = userAllData?.[0]?.isVendor === '1' ? 'VConnectVendorResetPassword' : 'VConnectAdminResetPassword';
    await axios
      .post(
        `${baseUrl}${apiAuth}${vendor}`,
        {
          UserID: userAllData?.[0]?.userId,
          Password: `${data?.oldPass}`,
          NewPassword: `${data?.newPass}`,
          ConfirmPassword: `${data?.confirmPass}`,
          ObjCommon: {
            LoggedInUserID: userAllData[0]?.loginUserId,
            CompanyID: userAllData[0]?.companyId,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(res => {
        const dt = res.data;
        setLoading(false);
        if (res.status === 200 && dt?.responseCode === '1') {
          // const encryptData = (Decoder(dt.responseDynamic))
          Swal.fire({
            text: dt.responseMessage,
            icon: 'success',
            allowOutsideClick: false,
            showConfirmButton: false,
            width: '25rem',
            timer: 2000,
          });
          setTimeout(() => {
            logout();
          }, 2000);
        } else if (dt?.responseCode === '0') {
          toast.error(dt.responseMessage || 'An error occurred', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: 'light',
            transition: Bounce,
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleSsoLogout = async () => {
    await axios.post(`${baseUrl}auth/VConnectSSOLogout`,
      {}, // body (empty)
      {
        withCredentials: client === 'DEN_HATHWAY' ? true : false,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  };


  // function call for logout
  const logout = () => {
    if (client === 'DEN_HATHWAY') {
      handleSsoLogout()
    }
    dispatch(resetChatNotificationData());
    localStorage.clear();
    if (userAllData[0]?.isVendor === '1') {
      navigate('/Vendor');
    } else {
      navigate('/');
    }
  };

  const handleMenuClick = menu => {
    setOpenMenu(openMenu === menu ? null : menu);
  };
  const start = (
    <div className="nav-left-content">
      <i
        className="pi pi-bars"
        style={{
          color: 'white',
          fontSize: '25px',
          marginLeft: '25px',
          cursor: 'pointer',
        }}
        onClick={() => {
          setShowSidebar(true);
        }}
      ></i>
      {client === 'Atomberg' && <img src={atomberg_nav_logo} alt="logo" className="nav-logo" />}
    </div>
  );
  const handleUserSection = action => {
    resetPassFormik.resetForm();
    setVisible(action);
  };

  const end = (
    <div className="nav-right-content">
      {notificationData?.length > 0 && (
        <i
          className="pi pi-bell p-overlay-badge"
          style={{ fontSize: '1.5rem', marginRight: '18px', cursor: 'pointer' }}
          onClick={e => {
            e.stopPropagation();
            handleUserSection('NOTIFICATION');
          }}
        >
          <Badge value={notificationData?.length} severity="danger"></Badge>
        </i>
      )}
      <Avatar icon="pi pi-user" className="navbar-header-avatar" shape="circle" onClick={() => handleUserSection('USER')} />
      <p className="user-name" onClick={() => handleUserSection('USER')} style={{ color: 'white', cursor: 'pointer' }}>
        {userAllData[0]?.userName} <i className="pi pi-chevron-circle-down"></i>
      </p>
    </div>
  );

  const customHeader = (
    <div className="nav-side-header">
      <img
        src={
          client === 'NKG'
            ? nkg_sidebar_logo
            : client === 'Atomberg'
              ? atomberg_sidebar_logo
              : client === 'Softgel'
                ? softGel_sidebar_logo :
                client === "DEN_HATHWAY" ? den_hathway_logo :
                  vconnect_sidebar_logo
        }
        alt=""
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );

  // close the attachment menu after clicking outside
  const handleClickOutside = event => {
    if (!event.target.closest('#user-details') && !event.target.closest('.user-name') && !event.target.closest('#msg-notification')) {
      setVisible('');
    }
  };

  // Bind the handleClickOutside to the document click event
  document.addEventListener('click', handleClickOutside);

  const handleNotification = item => {
    dispatch(setmailData(item?.Receiver?.UserCode));
    const routeMap = {
      QUALITYREJECTION: '/Admin/InventoryManagement/QualityRejection/List',
      MATERIALMASTER: '/Admin/Masters/Material',
      JOURNALVOUCHER: '/Admin/JournalVoucher/List',
      PURCHASEORDER: '/Admin/Report/PurchaseOrder',
      SUPREGFORM: '/Admin/Report/VendorList',
      INVOICE: '/Admin/Report/VendorInvoice',
    };
    const page = item?.FormCode?.toUpperCase();
    const targetPath = routeMap[page];
    navigate(targetPath);
  };

  return (
    <>
      {loading ? <Oval /> : null}
      <div className="custom-header">
        <div className="nav-container sticky-header">
          <div className="">
            <Menubar start={start} end={end} />
          </div>
          <div className="card flex justify-content-center">
            <Sidebar header={customHeader} visible={showSidebar} onHide={() => setShowSidebar(false)}>
              <div className="nav-sidebar-body">
                <div className="sidebar-items">
                  {sidebarMenu &&
                    sidebarMenu
                      .filter(item => item?.ParentMenuID === 0)
                      .map(item => (

                        <div key={item.MenuID} className="menu-main">
                          <div
                            className="d-flex mb-1 justify-content-between menu-button"
                            onClick={() => {
                              if (sidebarMenu.some(subItem => subItem.ParentMenuID === item.MenuID)) {
                                handleMenuClick(item.MenuName);
                              }
                            }}
                          >
                            <div className="d-flex">
                              <div>{/* <i  className={item.MenuIcon}></i> */}</div>
                              <div>
                                <span className="menu-tabs">
                                  {item.MenuURL ? (
                                    <Link to={item.MenuURL} className="navbar-content">
                                      {item.MenuName}
                                    </Link>
                                  ) : (
                                    <span className="navbar-content">{item.MenuName}</span>
                                  )}
                                </span>
                              </div>
                            </div>
                            <div>
                              {openMenu === item.MenuName && sidebarMenu.some(subItem => subItem.ParentMenuID === item.MenuID) ? (
                                <IoMdArrowDropup className="navbar-content icon-main fs-5" />
                              ) : null}
                              {openMenu !== item.MenuName && sidebarMenu.some(subItem => subItem.ParentMenuID === item.MenuID) ? (
                                <IoMdArrowDropdown className="navbar-content icon-main fs-5" />
                              ) : null}
                            </div>
                          </div>
                          <ul className={`Submenu ${openMenu === item.MenuName ? 'open' : ''}`}>
                            {sidebarMenu.map(subItem => {
                              if (subItem.ParentMenuID === item.MenuID) {
                                // const menuID = Base64.encode(item?.MenuID)
                                return (
                                  <li key={subItem.MenuID} className="list-group-item menu-tabs" style={{ fontSize: '13px' }}>
                                    {/* <i className={subItem.MenuIcon}></i> */}
                                    <Link to={`${subItem.MenuURL}?key=${item?.MenuID}`} className="navbar-content">
                                      <i
                                        className="pi pi-stop-circle"
                                        style={{
                                          fontSize: '10px',
                                          marginRight: '10px',
                                        }}
                                      ></i>
                                      {subItem.MenuName}
                                    </Link>
                                  </li>
                                );
                              }
                              return null;
                            })}
                          </ul>
                        </div>
                      ))}
                </div>
                <div className="kh-sidebar-btn-wrap">
                  <Link
                    to="/Admin/KnowledgeHub"
                    className="kh-sidebar-btn"
                    onClick={() => setShowSidebar(false)}
                  >
                    <FiBookOpen className="kh-sidebar-btn-icon" />
                    <span>Knowledge Hub</span>
                  </Link>
                </div>
              </div>
            </Sidebar>
          </div>
          {visible === 'USER' ? (
            <div id="user-details" className="user-section">
              <div className="user-header">
                <div className="user-detail">
                  <Avatar icon="pi pi-user" className="navbar-header-avatar" size="large" shape="circle" />
                  <p
                    style={{
                      fontSize: `${userAllData[0]?.isVendor === '1' ? '12px' : '15px'}`,
                    }}
                  >
                    {userAllData[0]?.userName}
                  </p>
                </div>
                <button className="view-profile-btn"> View Profile</button>
              </div>
              <hr />
              <div className="user-mid">
                <h6
                  className="logout-text"
                  style={{ fontSize: '13px' }}
                  onClick={() => {
                    setResetPass(true);
                    setVisible('PASSWORD');
                  }}
                >
                  <i className="pi pi-lock" style={{ marginRight: '10px' }}></i> Reset Password
                </h6>
              </div>
              <hr />
              <div className="user-footer">
                <h6 className="logout-text" style={{ fontSize: '13px' }} onClick={logout}>
                  <i className="pi pi-sign-out" style={{ marginRight: '10px' }}></i> Logout
                </h6>
              </div>
            </div>
          ) : (
            ''
          )}
          {visible === 'NOTIFICATION' ? (
            <div id="msg-notification" className="notification-section">
              {notificationData &&
                notificationData.map((item, index) => {
                  const time = getNotificationTime(item?.SendDate);
                  const formCode = item?.FormCode?.toUpperCase();
                  const groupName =
                    formCode === 'QUALITYREJECTION'
                      ? 'Quality Rejection'
                      : formCode === 'MATERIALMASTER'
                        ? 'Material Master'
                        : formCode === 'JOURNALVOUCHER'
                          ? 'Journal Voucher'
                          : formCode === 'PURCHASEORDER'
                            ? 'Purchase Order'
                            : formCode === 'SUPREGFORM'
                              ? 'Onboarding'
                              : formCode === 'INVOICE'
                                ? 'Invoice'
                                : '';
                  return (
                    <div key={index} className="user-notification" onClick={() => handleNotification(item)}>
                      <div className="user-details">
                        <div className="avatar-container">
                          <Avatar className="chat-avatar" shape="circle" icon="pi pi-users" />
                        </div>
                        <div className="notification-info">
                          <span className="group-name">
                            {groupName} - {item?.Receiver?.UserCode}
                          </span>
                          <span className="user-message">
                            <span className="user-name">{item?.Sender?.UserName}</span>:
                            <span className="message-content">{item?.Message}</span>
                          </span>
                        </div>
                      </div>
                      <span className="notification-time">{time}</span>
                    </div>
                  );
                })}
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
      <div className="reset-dialog">
        <Dialog visible={resetPass} modal header={null} closable={false} blockScroll={true} className="reset-form-dialog">
          <div className="reset-form-body">
            <div className="reset-form">
              <form onSubmit={resetPassFormik.handleSubmit}>
                <div className="login-head">
                  <h2>Reset / Change Password</h2>
                </div>
                <div className="reset-input-field">
                  <label htmlFor="" className="login-label">
                    Current Password
                  </label>
                  <InputText
                    id="oldPass"
                    className="reset-pass-input"
                    value={resetPassFormik.values.oldPass}
                    onChange={resetPassFormik.handleChange}
                    placeholder="Enter old password"
                    autoComplete="off"
                  />
                  {getResetFormErrorMessage('oldPass')}
                </div>
                <div className="reset-input-field">
                  <div className="new-pass-label">
                    <label htmlFor="" className="login-label">
                      New Password
                    </label>
                    <Tooltip target=".custom-tooltip-btn">
                      <div className="password-policy-container">
                        <div className="password-policy-popup">
                          <h3>Password Policy</h3>
                          <p>
                            A password policy is a set of rules designed to increase the security of your account by encouraging users to
                            create and use strong passwords.
                          </p>
                          <p>
                            The existing password policy can be modified below. This password policy applies to all people who are
                            registered in this account.
                          </p>
                          <ul>
                            <li>✔ Minimum password length: 6</li>
                            <li>✔ Maximum password length: 16</li>
                            <li>✔ Require at least one uppercase letter</li>
                            <li>✔ Require at least one lowercase letter</li>
                            <li>✔ Require at least one number</li>
                            <li>✔ Require at least one symbol character</li>
                          </ul>
                        </div>
                      </div>
                    </Tooltip>
                    <span className="pass-info">
                      <i className="pi pi-lock custom-tooltip-btn" style={{ color: '#fdb813', cursor: 'pointer' }}></i>
                    </span>
                  </div>
                  <InputText
                    type={showNewPassword ? 'text' : 'password'}
                    id="newPass"
                    maxLength="16"
                    autoomplete="off"
                    className="reset-pass-input"
                    value={resetPassFormik.values.newPass}
                    onChange={resetPassFormik.handleChange}
                    placeholder="Enter new password"
                    autoComplete="off"
                  />
                  <span onClick={() => setShowNewPassword(!showNewPassword)} className="show-hide-pass">
                    {showNewPassword ? (
                      <i className="pi pi-eye" style={{ cursor: 'pointer', color: '#fdb813' }}></i>
                    ) : (
                      <i className="pi pi-eye-slash" style={{ cursor: 'pointer', color: '#fdb813' }}></i>
                    )}
                  </span>
                  {getResetFormErrorMessage('newPass')}
                </div>
                <div className="reset-input-field">
                  <label htmlFor="" className="login-label">
                    Confirm Password
                  </label>
                  <InputText
                    type={showConfirmPassword ? 'text' : 'password'}
                    id="confirmPass"
                    autoomplete="off"
                    maxLength="16"
                    className="reset-pass-input"
                    value={resetPassFormik.values.confirmPass}
                    onChange={resetPassFormik.handleChange}
                    placeholder="Enter confirm password"
                    autoComplete="off"
                  />
                  <span onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="show-hide-pass">
                    {showConfirmPassword ? (
                      <i className="pi pi-eye" style={{ cursor: 'pointer', color: '#fdb813' }}></i>
                    ) : (
                      <i className="pi pi-eye-slash" style={{ cursor: 'pointer', color: '#fdb813' }}></i>
                    )}
                  </span>
                  {getResetFormErrorMessage('confirmPass')}
                </div>
                <div className="reset-pass-btn">
                  <button type="submit">Submit</button>
                  <button type="button" onClick={() => setResetPass(false)}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Dialog>
      </div>
      <div>
        <ToastContainer className="custom-toast-container" />
      </div>
    </>
  );
}
